/* Neomen 滚动渐入 2026-07-17 */
(function(){
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var sel='.shopify-section .card-wrapper,.shopify-section .multicolumn-card,'+
          '.shopify-section .banner__box,.shopify-section .title-wrapper-with-link,'+
          '.rich-text__wrapper,.image-with-text__grid';
  var els=document.querySelectorAll(sel);
  els.forEach(function(el,i){ el.classList.add('nm-reveal');
    el.style.transitionDelay=(i%4)*70+'ms'; });
  var io=new IntersectionObserver(function(es){ es.forEach(function(e){
    if(e.isIntersecting){ e.target.classList.add('nm-in'); io.unobserve(e.target); } });
  },{threshold:.12});
  els.forEach(function(el){ io.observe(el); });
})();
